<template lang="pug">
  .card-list
    .card-list__container.container
      Card(
        class="card-list__card"
        v-for="card in $store.state['item'].items"
        :key="card.id"
        :card="card"
        @cardPick="pickHandler(card.id)"
      )
</template>

<script>
import Card from "../components/Card";
import {mapActions} from "vuex";

export default {
  name: "CardList",
  components: {Card},
  methods: {
    ...mapActions('item', ['setCurrentItem', 'clearItemDependencies']),
    pickHandler(id) {
      this.setCurrentItem(id);
      this.clearItemDependencies();
      this.$router.go(-1);
    }
  }
};
</script>
